<div class="wrapper" [class.view-icon-danger]="hasWarning">
	<span *ngIf="+params.value !== 0">{{ params.value }}</span>
	<app-icon-view
		[iconCls]="!enabled() ? 'icon--gray icon--no-align disabled' : ' icon--no-align icon--secondary'"
		(click)="onViewClick()"
	></app-icon-view>
</div>
